<mat-dialog-content style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div fxLayoutAlign="center center">
		<mat-spinner [diameter]="30"></mat-spinner>
	</div>
	<div fxLayoutAlign="center center">Please wait..</div>
</mat-dialog-content>
